<template>
  <div class='home'>
    <PurchasingTypeList
      v-show='listView'
      @newPurchasingType='onClickNewFromList'
      @editPurchasingType='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <PurchasingTypeForm
      v-show='formView'
      :purchasingType='purchasingType'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import PurchasingTypeList from '@/components/purchasing-type/PurchasingTypeList.vue'
import PurchasingTypeForm from '@/components/purchasing-type/PurchasingTypeForm.vue'

export default {
  name: 'Purchasing_Type',
  components: {
    PurchasingTypeList,
    PurchasingTypeForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      purchasingType: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.purchasingType = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.purchasingType = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.purchasingType = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
